import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const globalSettingsIssuesStatusesRoute: InvariantJiraRoute = {
	name: 'global-settings-issues-statuses',
	path: '/secure/admin/ViewStatuses.jspa',
};
